import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Typography,
} from "@mui/material";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { useState } from "react";
export interface IFormWrapper extends IWrapper {
  title: string;
  bgcolor?: string;
  collapsible?: boolean;
}
export function FormWrapper(props: IFormWrapper) {
  const [open, setOpen] = useState(true);
  const handleChange = (event: React.SyntheticEvent, isExpanded: boolean) => {
    if (props.collapsible !== false) {
      setOpen(isExpanded);
    }
  };
  return (
    <Box
      sx={{
        border: "1px solid #fff6f6",
        boxShadow: "3px 3px 15px #fff6f6, -3px -3px 15px #fff6f6",
        borderRadius: 5,
        mb: 2,
        height: "100%",
      }}
    >
      <Accordion
        disableGutters
        defaultExpanded
        onChange={handleChange}
        expanded={open}
      >
        <AccordionSummary
          sx={{
            p: 0,
            m: 0,
            boxShadow: "none !important",
            bgcolor: "transparent !important",
          }}
        >
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              p: 1,
              pl: 2,
              bgcolor: "primary.main",
              borderTopLeftRadius: 20,
              borderTopRightRadius: 20,
            }}
          >
            <Typography variant="h6" color="white" fontWeight={700}>
              {props.title}
            </Typography>
            {props.collapsible !== false && (
              <Box>
                {!open ? (
                  <ExpandMoreIcon sx={{ color: "white" }} />
                ) : (
                  <KeyboardArrowUpIcon sx={{ color: "white" }} />
                )}
              </Box>
            )}
          </Box>
        </AccordionSummary>

        <AccordionDetails>
          <Box p={3}>{props.children}</Box>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}
